import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Form, Input} from 'antd'
import Button from 'components/shared/Button'
import { useTranslation } from 'react-i18next'

function OtpForm({email, onSubmit, onCancel, loading}) {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [, forceUpdate] = useState()

  useEffect(() => {
    forceUpdate({})
  }, [])

  return (
    <Form form={form} onFinish={onSubmit} className="login-form">
      {t('otpForm.otpSent', { email })}
      <Form.Item
        name="otp"
        rules={[{ required: true, message: t('otpForm.otpRequired') }]}
      >
        <Input placeholder={t('otpForm.otpPlaceholder')} />
      </Form.Item>

      <Form.Item className="login-button" shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={loading}
            disabled={
              !form.isFieldsTouched(true) ||
              form.getFieldsError().filter(({errors}) => errors.length).length
            }
          >
            {t('otpForm.login')}
          </Button>
        )}
      </Form.Item>
      <Button
        className="login-form-button"
        onClick={onCancel}
      >
        {t('otpForm.cancel')}
      </Button>
    </Form>
  )
}

OtpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default OtpForm
